"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("../index");
exports.ConversionAPI = {
    getConversions: function (companyId) {
        return index_1.axios.get("/api/v1/company/" + companyId + "/conversions").then(function (response) {
            var conversions = response.data.data;
            return conversions;
        });
    },
    getConversionById: function (companyId, conversionId) {
        return index_1.axios.get("/api/v1/company/" + companyId + "/conversion/" + conversionId).then(function (response) {
            var conversions = response.data;
            return conversions;
        });
    },
    createConversion: function (companyId, createObject) {
        return index_1.axios.post("/api/v1/company/" + companyId + "/conversion", createObject).then(function (response) {
            var conversion = response.data;
            return conversion;
        });
    },
    updateConversion: function (companyId, conversionId, updateObject) {
        return index_1.axios.put("/api/v1/company/" + companyId + "/conversion/" + conversionId, updateObject).then(function (response) {
            var conversion = response.data;
            return conversion;
        });
    },
    completeConversion: function (companyId, conversionId) {
        return index_1.axios.post("/api/v1/company/" + companyId + "/conversion/" + conversionId + "/complete").then(function (response) {
            var conversion = response.data;
            return conversion;
        });
    },
    cancelConversion: function (companyId, conversionId) {
        return index_1.axios.post("/api/v1/company/" + companyId + "/conversion/" + conversionId + "/cancel").then(function (response) {
            var conversion = response.data;
            return conversion;
        });
    },
};
//# sourceMappingURL=ConversionAPI.js.map